import { useEffect, useState } from 'react';
import { useFragment, graphql } from 'react-relay';
import { getAbTestV2, trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';

import { usePdpNetPriceVariant_item$key } from './__generated__/usePdpNetPriceVariant_item.graphql';
import { usePdpNetPriceVariant_user$key } from './__generated__/usePdpNetPriceVariant_user.graphql';

const itemFragment = graphql`
    fragment usePdpNetPriceVariant_item on Item {
        isFurniture
        isAuctionEnabled
    }
`;

const userFragment = graphql`
    fragment usePdpNetPriceVariant_user on User {
        isVerifiedTrade
    }
`;

export const usePdpNetPriceVariant = ({
    item: itemRef,
    user: userRef,
}: {
    item: usePdpNetPriceVariant_item$key;
    user: usePdpNetPriceVariant_user$key | null;
}): boolean | null => {
    const user = useFragment(userFragment, userRef);
    const item = useFragment(itemFragment, itemRef);
    const { isVerifiedTrade } = user || {};
    const { isAuctionEnabled, isFurniture } = item || {};
    const hasValidTestCriteria = isVerifiedTrade && !isAuctionEnabled && isFurniture;

    const [isPdpNetPriceVariantClient, setisPdpNetPriceVariantClient] = useState<boolean | null>(
        null
    );

    useEffect(() => {
        if (hasValidTestCriteria) {
            setisPdpNetPriceVariantClient(getAbTestV2('pdpNetPrice')?.variant === 'variant');
            trackAbTestV2Variant('pdpNetPrice');
        }
    }, [hasValidTestCriteria]);

    return isPdpNetPriceVariantClient;
};
